
/*!
 * Copyright (C) 2024, Peppermill Inc.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *//*
 *		2024-05-17 (jhoward)
 *			- Refactor calendar month from hotelCalendar.vue to hotelCalendarMonth.vue.
 */

import {defineComponent, PropType} from 'vue'
import HotelCalendarDay, {CalendarDay} from "./hotelCalendarDay.vue";

export interface CalendarMonth {
  weeks: CalendarDay[][],
  title: string,
  year: number;
  month: number;
}

export default defineComponent({
  name: "hotelCalendarMonth",
  emits: {
    close: () => true,
    seek: (direction: number) => true
  },
  components: {HotelCalendarDay},
  props: {
    month: {
      type: Object as PropType<CalendarMonth>,
      required: true
    }
  },
  data() {
    return {
      dayHeaders: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
    };
  },
  methods: {
    handleDayKeydown(event: KeyboardEvent, day: CalendarDay) {
      if (event.key === 'Tab') {
        if (!event.shiftKey && this.isLastDayOfMonth(day)) {
          this.$emit('seek', 1);
        } else if (event.shiftKey && this.isFirstDayOfMonth(day)) {
          this.$emit('seek', -1);
        }
      }
    },
    isLastDayOfMonth(day: CalendarDay): boolean {
      return !!day.DATE && window.pepDateFunctions.addDays(day.DATE, 1).getMonth() !== day.DATE.getMonth();
    },
    isFirstDayOfMonth(day: CalendarDay): boolean {
      return !!day.DATE && window.pepDateFunctions.addDays(day.DATE, -1).getMonth() !== day.DATE.getMonth();
    },
  }
})
